module.exports = __webpack_public_path__ + "img/social-chart.e35d1097.svg";